import CurrencyConverter from "@/components/CustomUI/modules/CurrencyConverter";
import { Button } from "@/components/ui/button";
import { Line } from "@/components/CustomUI/modules/Loaders";

const Active = ({
  voucher,
  loading,
  totalDiscountValue,
  removeCurrentCoupon,
}) => {
  if (!voucher || !Object.keys(voucher).length) return null;

  return (
    <div className="mb-5 drop-shadow-md bg-[#ebffff] w-full font-light text-sm p-3 border border-dashed border-sky-500 rounded-tl-lg rounded-br-lg ">
      <div className="flex items-center justify-between">
        <span className="font-bold xl:text-base">
          {voucher.name ? "Voucher" : "Product Discount"} {"  "}
          {voucher.code && "( " + voucher.code + " )"}
        </span>
        {removeCurrentCoupon && (
          <div className="h-[35px]">
            {loading ? (
              <Line loading={true} />
            ) : (
              <Button
                variant="secondary"
                className="
                  bg-transparent hover:bg-transparent rounded-none 
                  px-2 py-0 border-0 items-center justify-between 
                  cursor-pointer underline text-sm
                "
                onClick={removeCurrentCoupon}
              >
                REMOVE
              </Button>
            )}
          </div>
        )}
      </div>

      {voucher.center_stones > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>Center Stone Discount</span>
          <span className="text-[#ff3a3a]">{voucher.center_stones} %</span>
        </div>
      )}

      {voucher.side_diamonds > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>Side Diamonds Discount</span>
          <span className="text-[#ff3a3a]">{voucher.side_diamonds} %</span>
        </div>
      )}

      {voucher.gemstones > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>Gemstones Discount</span>
          <span className="text-[#ff3a3a]">{voucher.gemstones} %</span>
        </div>
      )}

      {voucher.other_raw_materials > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>Raw Materials Discount</span>
          <span className="text-[#ff3a3a]">
            {voucher.other_raw_materials} %
          </span>
        </div>
      )}

      {voucher.making > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>Making Discount</span>
          <span className="text-[#ff3a3a]">{voucher.making} %</span>
        </div>
      )}

      {voucher.flat_percentage > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>Discount</span>
          <span className="text-[#ff3a3a]">
            FLAT {voucher.flat_percentage}% OFF
          </span>
        </div>
      )}

      {totalDiscountValue > 0 && (
        <div className="flex items-center justify-between pb-1">
          <span>You Save</span>
          <span className="text-[#59b859] font-bold">
            <CurrencyConverter amount={totalDiscountValue} />
          </span>
        </div>
      )}
    </div>
  );
};

export default Active;
